//action types

const SWITCH_DRAWER = "SWITCH_DRAWER";
const SWITCH_BACKDROP = "SWITCH_BACKDROP";
const NAVIGATE_SITE = "NAVIGATE_SITE";
const CHANGE_PROJECT_DETAILS = "CHANGE_PROJECT_DETAILS";

export {
    SWITCH_DRAWER, SWITCH_BACKDROP,
    NAVIGATE_SITE, 
    CHANGE_PROJECT_DETAILS
}